module.exports = __webpack_public_path__ + "img/knsu_gallery3.4815e8ed.jpg";